/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
// import TelephoneInput from 'react-telephone-input';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';

const { colors } = theme;

export const StyledInputPhone = styled(PhoneInput)`
  width: unset !important;
  input[type='tel'] {
    ${({ greyBlue }) => greyBlue && `background-color: ${colors.lightGray} !important;`}
    /* background-color: ${colors.greyBlue10} !important; */
    color: ${colors.black} !important;
    height: unset !important;
    border: 1px solid ${colors.translucentDarkBlue};
    ${({ noBorder }) => noBorder && 'border: none !important'};
    ${({ costpage }) =>
    costpage
    && `padding-top: 10px;
        padding-bottom: 10px;
        border: 1px solid #C9D8E8;
        border-radius: 12px;
        background-color: white !important;
    `}
    ${breakpoint('mobile', 'tablet')`
      border-radius: 10px;
    `}
    ${breakpoint('mobile', 'tablet')`
      ${({ campaign }) => campaign
      && `
        font-size: 13px;
      `
}
   `}
  }
 
`;
